// Détermine la PROCHAINE ÉTAPE de l'utilisateur à partir de son état RÉEL (bilan / programme / cycle).
// Utilisé après un paiement réussi (écran de succès) ET sur le tableau de bord.
// IMPORTANT : ne déclenche AUCUNE génération. On se contente d'orienter vers l'écran où l'action
// explicite existe. Aucune logique de paiement, d'abonnement, de moteur ou de bibliothèque ici.
export function deriveNextStep({ profile, program, cycle } = {}) {
  const bilanDone = profile?.status === "complete";
  const hasProgram = !!program;
  const cycleFinished = !!cycle?.finished;

  if (!bilanDone) {
    return { key: "bilan", label: "Terminer mon bilan", route: "/bilan",
      dashboard: "Votre accès est actif — terminez votre bilan" };
  }
  if (!hasProgram) {
    return { key: "generate", label: "Générer mon programme", route: "/app",
      dashboard: "Votre bilan est terminé — générez maintenant votre programme" };
  }
  if (cycleFinished) {
    return { key: "next_cycle", label: "Préparer mon prochain cycle", route: "/programme",
      dashboard: "Votre prochain cycle est prêt à être préparé" };
  }
  return { key: "program", label: "Découvrir mon programme", route: "/programme", dashboard: null };
}
